import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { BOM_DASHBOARD_API } from "./apiRoutes";

interface UseGetOpenIncidentDashboardCountProps {
  communityId: string;
  year: string;
  userId?: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getOpenIncidentDashboardCount = async (
  communityId: string,
  year: string,
  userId?: string
) =>
  await axiosAuth.get(
    `${BOM_DASHBOARD_API(communityId)}/count/open/incident?year=${year}${
      userId ? "&userId=" + userId : ""
    }`
  );

const useGetOpenIncidentDashboardCount = ({
  queryParams,
  communityId,
  year,
  userId,
}: UseGetOpenIncidentDashboardCountProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["open-incident-dashboard-count", communityId],
    queryFn: () => getOpenIncidentDashboardCount(communityId, year, userId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && !!year && (queryParams?.enabled ?? true),
  });
};

export default useGetOpenIncidentDashboardCount;
